import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;
class Backup {
    download = async (code: any) => {
      const response = await axios.get<any>(`${API_URL}download-database-backup`)
          .catch((e) => {
          throw e.message;
        });
        return response.data.user;
      };
}

export default new Backup();